const SET_AUTHORIZED_FLAG = 'SET_AUTHORIZED_FLAG'
const SET_CURRENT_USER = 'SET_CURRENT_USER'
const UNSET_CURRENT_USER = 'UNSET_CURRENT_USER'
const SET_LOGOUT_USER = 'SET_LOGOUT_USER'
const ENABLE_GLOBAL_LOADER = 'ENABLE_GLOBAL_LOADER'
const DISABLE_GLOBAL_LOADER = 'DISABLE_GLOBAL_LOADER'
const DISPLAY_SNACKBAR = 'DISPLAY_SNACKBAR'
const HIDE_SNACKBAR = 'HIDE_SNACKBAR'
const INCREMENT_SESSION_TIME = 'INCREMENT_SESSION_TIME'
const INACTIVITY_LOGOUT = 'INACTIVITY_LOGOUT'
const SET_SYSTEM_INFO = 'SET_SYSTEM_INFO'
const SET_CALENDAR_EVENTS_COUNT = 'SET_CALENDAR_EVENTS_COUNT'
const SET_REDIRECT_PATH = 'SET_REDIRECT_PATH'
const UNSET_REDIRECT_PATH = 'UNSET_REDIRECT_PATH'
const SET_WCAG_CONTRAST = 'SET_WCAG_CONTRAST'
const SET_WCAG_FONTS = 'SET_WCAG_FONTS'
const INCREMENT_RELOAD_COUNTER = 'INCREMENT_RELOAD_COUNTER'
const SET_VOTINGS_NO_VOTE = 'SET_VOTINGS_NO_VOTE'
const SET_VIEW_PROPS = 'SET_VIEW_PROPS'
const RESET_VIEW_PROPS = 'RESET_VIEW_PROPS'

export default {
  SET_AUTHORIZED_FLAG,
  SET_CURRENT_USER,
  UNSET_CURRENT_USER,
  SET_LOGOUT_USER,
  ENABLE_GLOBAL_LOADER,
  DISABLE_GLOBAL_LOADER,
  DISPLAY_SNACKBAR,
  HIDE_SNACKBAR,
  INCREMENT_SESSION_TIME,
  INACTIVITY_LOGOUT,
  SET_SYSTEM_INFO,
  SET_CALENDAR_EVENTS_COUNT,
  SET_REDIRECT_PATH,
  UNSET_REDIRECT_PATH,
  SET_WCAG_CONTRAST,
  SET_WCAG_FONTS,
  INCREMENT_RELOAD_COUNTER,
  SET_VOTINGS_NO_VOTE,
  SET_VIEW_PROPS,
  RESET_VIEW_PROPS
}
